import { Theme } from '../../../../types/shared'
import {
  ChartEventBadgeState,
  IChartEventBadgeProps,
  getChartEventBadgeColors,
  getChartEventBageColors,
} from '../../../utils/chart-events-utils'

export function getChartEventDividendsSvgString({
  theme = Theme.light,
  state = ChartEventBadgeState.default,
  width,
}: IChartEventBadgeProps) {
  const { outerStroke, innerStroke, innerFill, textFill } = getChartEventBadgeColors({
    theme,
    state,
    colors: getChartEventBageColors('blue'),
  })

  // browsers have issue rendering non-straight paths when one have same edge as other,
  // outer stroke line edge is same as inner fill edge and when browser rasterize diagonal line it breaks it down to pixels with variable opacity/color
  // but if there aren't opacity pixels on same place render is correct, due that adding fill solve incorrect color of colliding opacity pixels
  return `<svg
      xmlns="http://www.w3.org/2000/svg"
      width="${width}"
      height="${width}"
      viewBox="0 0 24 24"
    >
      <rect x="1.5" y="1.5" width="21" height="21" rx="10.5" stroke="${outerStroke}" fill="${outerStroke}" />
      <rect x="3" y="3" width="18" height="18" rx="9" fill="${innerFill}" />
      <rect x="3" y="3" width="18" height="18" rx="9" stroke="${innerStroke}" fill="transparent" stroke-width="2" />

      <path
        d="M11.78 16H8.96V7.27h2.91c.86 0 1.6.18 2.2.53.62.34 1.1.84 1.42 1.5.33.64.5 1.42.5 2.32 0 .91-.17 1.7-.5 2.35a3.5 3.5 0 0 1-1.44 1.5c-.62.36-1.38.53-2.27.53Zm-1.5-1.15h1.43c.67 0 1.22-.13 1.66-.38.44-.25.77-.61.99-1.1.22-.47.33-1.06.33-1.75 0-.68-.11-1.26-.33-1.74a2.32 2.32 0 0 0-.97-1.09 3.16 3.16 0 0 0-1.6-.37h-1.51v6.43Z"
        fill="${textFill}"
      />
    </svg>`
}
